import { closeModal, openModal } from "./modal"

const forms = document.querySelectorAll("form[data-action]")
const emailRegExp =
	/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z 0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
const sendingSuccessModal = document.querySelector('[data-modal="success-order"]')

const showInpErr = (inp, errMessage) => {
  const inpWrapper = inp.closest('.input-wrapper')
  if (!inpWrapper) return
  const inpErr = inpWrapper.querySelector('.input-error')
  if (!inpErr) return
  inpWrapper.classList.add('invalid')
  inpErr.textContent = errMessage
}

forms.forEach(form => {
	const url = form.dataset.action
  const inputs = form.querySelectorAll('input')
  const textareas = form.querySelectorAll('textarea')
  const fields = [...inputs, ...textareas]
  const submitBtn = form.querySelector('button[type="submit"]')
  const fileInput = form.querySelector('input[type="file"]')
  const filesContainer = form.querySelector('.files-container')
  const policyCheckbox = form.querySelector('input[name="policy-agreement"]')
  let filesArray = []

	const syncSubmitButton = () => {
		if (!submitBtn) return
		const hasInvalid = !!form.querySelector(".invalid")
		if (policyCheckbox) {
			submitBtn.disabled = !policyCheckbox.checked || hasInvalid
		} else {
			submitBtn.disabled = hasInvalid
		}
	}

	const resetForm = () => {
    inputs.forEach(inp => {
      inp.value = ''
      inp.checked = false
    })
    textareas.forEach(area => area.value = '')
    if (filesContainer) {
      filesContainer.innerHTML = ''
    }
    filesArray = []
		syncSubmitButton()
  }

	const clearFieldInvalid = field => {
		field.closest(".input-wrapper")?.classList.remove("invalid")
		field.closest(".form-agreement__item")?.classList.remove("invalid")
		field.closest(".quick-request__check")?.classList.remove("invalid")
	}

	fields.forEach(field => {
		const onFieldUpdate = () => {
			clearFieldInvalid(field)
			syncSubmitButton()
		}
		field.addEventListener("input", onFieldUpdate)
		field.addEventListener("change", onFieldUpdate)
	})

	syncSubmitButton()

	fileInput?.addEventListener('change', () => {
    const newFiles = Array.from(fileInput.files).filter(file => file.size < 25 * 1024 * 1024)
    filesArray = [...filesArray, ...newFiles]
    fileInput.value = ''
    renderFileList()
  })

	const removeFile = (idx) => {
    filesArray.splice(idx, 1)
    renderFileList()
  }

	const renderFileList = () => {
		if (!filesContainer) return
		filesContainer.innerHTML = ""

		filesArray.forEach((file, idx) => {
			const fileItem = document.createElement("div")
			const fileHeader = document.createElement("div")
			const fileName = document.createElement("p")
			const fileSize = document.createElement("p")
			const removeBtn = document.createElement("button")

			removeBtn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M1 11L11 1" stroke="#A6A6A6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11 11L1 1" stroke="#A6A6A6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>  
      `

			fileName.textContent = file.name

			const sizeInMB = (file.size / (1024 * 1024)).toFixed(2)
			fileSize.textContent = `${sizeInMB} Мб`

			removeBtn.addEventListener("click", () => removeFile(idx))

			fileItem.classList.add("file-item")
			fileHeader.classList.add("file-item__header")

			fileItem.append(fileHeader, fileSize)
			fileHeader.append(fileName, removeBtn)
			filesContainer.append(fileItem)
		})
	}

	const validate = () => {
    let isValid = true

    fields.forEach(field => {
      const isHidden = field.closest('.hidden')

      if (isHidden) return

      if (field.name === "policy-agreement" && !field.checked) {
        field.closest(".form-agreement__item, .quick-request__check")?.classList.add("invalid")
        isValid = false
      }

      if (field.type === 'tel' && field.value.trim() !== "") {
        if (field.value.replace(/\D/g, '').length < 11) {
          showInpErr(field, 'Не корректный номер телефона')
          isValid = false
        }
      }

      if (field.type === 'email') {
        if (field.value.trim() === '') {
          showInpErr(field, 'Введите email')
          isValid = false
        } else if (!emailRegExp.test(field.value)) {
          showInpErr(field, 'Не корректный email')
          isValid = false
        }
      }

      if (field.required && field.value.trim() === '') {
        showInpErr(field, 'Это поле обязательно для заполнения')
        isValid = false
      }
    })

    if (!isValid) syncSubmitButton()
    return isValid
  }

	form.addEventListener("submit", e => {
		e.preventDefault()

		if (!validate()) return
		const formData = new FormData(form)

		filesArray.forEach((file, idx) => {
			formData.append(`file${idx}`, file)
		})

		fetch(url, {
			method: "POST",
			body: formData,
		})
			.then(() => {
				const goal = form.dataset.goal
				if (goal && typeof ym !== "undefined" && Ya && Ya._metrika && Ya._metrika.getCounters) {
					const counterId = Ya._metrika.getCounters()[0]?.id
					if (counterId) {
						ym(counterId, "reachGoal", goal)
					}
				}

				const openedModal = document.querySelector(".modal-overlay.show")
				if (openedModal) closeModal(openedModal, false)
				openModal(sendingSuccessModal)
				resetForm()
			})
			.catch(e => {
				console.log(e)
			})
	})
})
